module.exports = __webpack_public_path__ + "platform/chrome_logo.png";